import { getPageInfo } from '#commerce/gtm/page'

export const useBloomreach = () => {
  const { $gtm } = useNuxtApp()
  const route = useRoute()
  const locale = useLocale()
  const currency = useCurrencyCode(locale)
  const pending = ref<boolean>(false)

  const handleBloomreachProductClick = (product, position: number, title: string | undefined, path: string) => {
    if (product) {
      const [placement] = path ? [extractPageType(path)] : getPageInfo(route, {})
      const _product = {
        ...product,
        price: Number.parseFloat(product.price.lowOriginal),
        salePrice: Number.parseFloat(product.price.lowCurrent)
      }

      $gtm.push('product.onProductRecClick', _product, position, {
        action: 'Click Recommendation',
        currency: currency[locale],
        placement,
        title,
        vendor: 'bloomreach'
      })
    }
  }

  // SSR bloomreach products will be handled by prefetch-p13n
  if (!isServer()) {
    const revaluate = (window as any)?.revaluateBloomreach as undefined | (() => Promise<void>)
    if (typeof revaluate === 'function') {
      pending.value = true
      revaluate().finally(() => {
        pending.value = false
      })
    }
  }

  return {
    handleBloomreachProductClick,
    pending
  }
}
